export enum PositionType {
    Relative = "relative",
    Fixed = "fixed",
}

export interface HeaderInnerState {
    headerPosition: PositionType;
    isOnlyMenuBarDisplayed: boolean;
}
